<template>
  <br />
  <div class="pt-3">
    <div
      class="text-center"
      style="display: flex; justify-content: center; align-items: center"
    >
      <img src="@/assets/svg/vec2-empty.svg" />
    </div>
    <br />
    <div class="empty-state text-center">No {{ type }} list available</div>
  </div>
</template>

<script>
export default {
  props: ["type"],
};
</script>

<style>
.empty-state {
  color: #667085;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}
</style>
